import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { UserService } from "../services/user.service";

@Injectable()
export class AppKycDetailsService {
  api_url: string = environment.apiEndPoint;

  constructor(private http: HttpClient, private userSvc: UserService) {}

  getToken() {
    return localStorage.getItem(environment.TOKEN_SECRET);
  }
  getSumsubStatus(id){
    return this.http.get<any>(this.api_url + 'sumsub/' + id)
  }
  getApplicants(userId){
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(`${this.api_url}applicant_data/${userId}`, configs)
  }
  getApplicantsStatus(applicantId){
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + 'applicant_status/' + applicantId,configs)
  }
  updateApplicant(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(this.api_url + "update-applicant", obj, configs);
  }
  summaryReport(id) {
    console.log(id,'98')
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}`, observe: 'response', responseType: 'blob'},
    };
    return this.http.get<any>(this.api_url + "summary-report/" + id, configs);
  }
}



// WEBPACK FOOTER //
// ./src/app/appkycdetails/appkycdetails.service.ts